import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import CBMediaQuery from '../../shared/CBMediaQuery';
import { getStyle, SERVICE_CHAIN } from '../../../utils/utils';
import CBSelectField from '../../shared/form_components/CBSelectField';
import { fetchChainCareServices as _fetchChainCareServices } from '../../../actions/chainActions';
import SettingsBusinessUnits from '../../SettingsView/SettingsViewComponents/SettingsBusinessUnits';
import SettingsOrganizationVehicleSettings from '../../SettingsView/SettingsViewComponents/SettingsOrganizationVehicleSettings';
import { T, cardStyle, selectStyle } from './chainSettingsV2Styles';

// Chain portal: the same toimipiste and per-vehicle settings pages the fleet
// portal has, for one of the chain's care-service customers at a time.
class SettingsChainCustomerVehiclesV2 extends React.Component {
  state = {
    organizationId: '',
  };

  componentDidMount() {
    const { chainId, fetchChainCareServices } = this.props;
    if (chainId) {
      fetchChainCareServices(chainId);
    }
  }

  getOrganizationOptions = () => {
    const { chainCareServices } = this.props;
    const seen = {};
    return (chainCareServices || [])
      .filter((cs) => cs.is_active && cs.organization && !seen[cs.organization] && (seen[cs.organization] = true))
      .map((cs) => ({ label: cs.organization_name || ('#' + cs.organization), value: String(cs.organization) }))
      .sort((a, b) => a.label.localeCompare(b.label, 'fi'));
  };

  render() {
    const { t, chainId } = this.props;
    const options = this.getOrganizationOptions();
    const organizationId = this.state.organizationId || (options.length ? options[0].value : '');

    return (
      <CBMediaQuery>
        {screenSize => (
          <div>
            <div style={getStyle(screenSize, styles, 'headerCard')}>
              <div style={getStyle(screenSize, styles, 'headerLeft')}>
                <div style={getStyle(screenSize, styles, 'iconBox')}>
                  <i className="pi pi-car" style={{ fontSize: 20, color: T.accent }} />
                </div>
                <div>
                  <h2 style={getStyle(screenSize, styles, 'title')}>{t('customerVehiclesTitle')}</h2>
                  <p style={getStyle(screenSize, styles, 'description')}>{t('customerVehiclesDescription')}</p>
                </div>
              </div>
              <div style={getStyle(screenSize, styles, 'selectorContainer')}>
                {options.length ? (
                  <CBSelectField
                    name='organization'
                    value={organizationId}
                    options={options}
                    onChange={(option) => this.setState({ organizationId: option.value })}
                    labelText={t('selectCustomerOrganization')}
                    inputStyle={selectStyle}
                    containerStyle={{ margin: 0 }}
                  />
                ) : (
                  <span style={getStyle(screenSize, styles, 'description')}>{t('noActiveCustomers')}</span>
                )}
              </div>
            </div>

            {organizationId && (
              <div style={getStyle(screenSize, styles, 'card')}>
                <SettingsBusinessUnits
                  embedded
                  organizationId={Number(organizationId)}
                  service={SERVICE_CHAIN}
                  chainId={chainId}
                />
              </div>
            )}
            {organizationId && (
              <div style={getStyle(screenSize, styles, 'card')}>
                <SettingsOrganizationVehicleSettings
                  embedded
                  organizationId={Number(organizationId)}
                  service={SERVICE_CHAIN}
                  chainId={chainId}
                />
              </div>
            )}
          </div>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    headerCard: {
      ...cardStyle,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      flexWrap: 'wrap',
      gap: 12,
      marginBottom: 20,
    },
    headerLeft: {
      display: 'flex',
      alignItems: 'center',
      gap: 16,
    },
    iconBox: {
      width: 48,
      height: 48,
      borderRadius: 12,
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    },
    title: {
      color: T.textPrimary,
      fontSize: 18,
      fontWeight: 600,
      margin: 0,
    },
    description: {
      color: T.textSecondary,
      fontSize: 13,
      margin: '4px 0 0 0',
    },
    selectorContainer: {
      minWidth: 260,
    },
    card: {
      ...cardStyle,
      marginBottom: 20,
    },
  },
};

function mapStateToProps(state) {
  return {
    chainCareServices: state.chain.chainCareServices,
  };
}

export default connect(
  mapStateToProps,
  { fetchChainCareServices: _fetchChainCareServices },
)(translate('ChainSettingsView')(SettingsChainCustomerVehiclesV2));
